import { BoxProps, Box } from "@chakra-ui/react";

const Spacer = (props: BoxProps) => {
    return <Box  my={1} h='0' w='100%' borderBottom='solid 1px' borderColor='gray.200' {...props}></Box>
}

export default Spacer;